import { render } from "./MemberTag.vue?vue&type=template&id=a7ddbb4c&scoped=true"
import script from "./MemberTag.vue?vue&type=script&lang=js"
export * from "./MemberTag.vue?vue&type=script&lang=js"

import "./MemberTag.vue?vue&type=style&index=0&id=a7ddbb4c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7ddbb4c"]])

export default __exports__